// The identity-resolution seam. Today: pass-through + optional
// TeamMembers displayName for channel sources. "Unique users" is reported
// PER SOURCE — the same human appears under different refs across sources
// (telegram handle / webapp UPN / MCP OS-user) and is NOT merged. A future
// alias-map points resolveIdentity at a canonical person with no UI rework.
import type { LedgerUser } from "./types.js";

export interface TeamMemberLite { source: string; handle: string; displayName: string }

// Channel sources whose userRef is a handle resolvable via TeamMembers.
// Update when new channel adapters land (see the api-contract Channel union).
const CHANNEL_SOURCES = new Set(["telegram", "slack"]);

export function resolveIdentity(source: string, userRef?: string, members: TeamMemberLite[] = []): LedgerUser {
  if (!userRef) return { source, ref: "unknown" };
  if (CHANNEL_SOURCES.has(source)) {
    const m = members.find((x) => x.source === source && x.handle.toLowerCase() === userRef.toLowerCase());
    if (m) return { source, ref: userRef, display: m.displayName };
  }
  return { source, ref: userRef };
}
